const formatDate = (stringDate, withTime = false) => {
  const date = new Date(stringDate);
  // Format the date object into the desired format (DD/MM/YYYY)

  const dateFormat = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  if (withTime) {
    dateFormat["hour"] = "2-digit";
    dateFormat["minute"] = "2-digit";
    dateFormat["second"] = "2-digit";
  }

  const formattedDate = date.toLocaleDateString("en-GB", dateFormat);
  return formattedDate;
};

// #30 / INV-23: contract dates are stored as UTC days and end_date is the
// renewal day. lastUsableDay prints the day before, so a September period
// reads 01.09.2026 → 30.09.2026, like the invoice mail (DD.MM.YYYY, UTC).
const formatTermDay = (iso, { lastUsableDay = false } = {}) => {
  if (!iso) return "—";
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return "—";
  const d = new Date(lastUsableDay ? t - 86400000 : t);
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  return `${dd}.${mm}.${d.getUTCFullYear()}`;
};

const formatContact = (number) => {
  // Convert the number to a string
  let str = number.toString();

  // Ensure the string is 10 digits long
  if (str.length !== 10) {
    str = "6845550102";
  }

  // Format the string
  const formatted = `(${str.slice(0, 3)}) ${str.slice(3, 6)}-${str.slice(6)}`;

  return formatted;
};

export function GlassCard({ children, className = "" }) {
  return (
    <div className={`glass-card p-6 ${className}`}>
      {children}
    </div>
  );
}

export function toCapitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}



export {
  formatDate,
  formatTermDay,
  formatContact,
};
